module.exports = __webpack_public_path__ + "static/img/517755b8-fa46-47b0-9d92-0ff403092854.96c089ee.png";